import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';
import logo from './logo.png';
import { MdArrowBack } from 'react-icons/md';

function PrivacyPolicy() {
	return (
		<div className="privacy-page">
			<header className="privacy-header">
				<div className="privacy-header-inner">
					<img src={logo} alt="mestprogramma logo" className="privacy-logo" />
					<h1>Privacybeleid</h1>
					<p className="privacy-subtitle">mestprogramma.be</p>
				</div>
			</header>

			<div className="privacy-content">
				<Link to="/" className="back-link">
					<MdArrowBack size={20} />
					<span>Terug naar hoofdpagina</span>
				</Link>

				<section className="privacy-section">
					<p className="intro-text">
						Mestprogramma, gevestigd aan Leuven, is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze privacyverklaring.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Contactgegevens</h2>
					<div className="info-box">
						<p><strong>Website:</strong> <a href="https://mestprogramma.be">https://mestprogramma.be</a></p>
						<p><strong>Locatie:</strong> Leuven</p>
						<p><strong>Functionaris Gegevensbescherming:</strong> De Keukelaere</p>
						<p><strong>E-mail:</strong> <a href="mailto:info@mestprogramma.be">info@mestprogramma.be</a></p>
					</div>
				</section>

				<section className="privacy-section">
					<h2>Persoonsgegevens die wij verwerken</h2>
					<p>
						Mestprogramma verwerkt je persoonsgegevens doordat je gebruik maakt van onze diensten en/of omdat je deze gegevens zelf aan ons verstrekt.
					</p>
					<p>Hieronder vind je een overzicht van de persoonsgegevens die wij verwerken:</p>
					<ul className="privacy-list">
						<li>Voor- en achternaam</li>
						<li>E-mailadres</li>
						<li>Overige persoonsgegevens die de klant actief verstrekt bijvoorbeeld door een profiel op jouw website aan te maken, in correspondentie en telefonisch</li>
					</ul>
				</section>

				<section className="privacy-section">
					<h2>Bijzondere en/of gevoelige persoonsgegevens</h2>
					<p>
						Onze website en/of dienst heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 16 jaar. Tenzij ze toestemming hebben van ouders of voogd. We kunnen echter niet controleren of een bezoeker ouder dan 16 is. Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten van hun kinderen, om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming.
					</p>
					<p>
						Als je er van overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben verzameld over een minderjarige, neem dan contact met ons op via <a href="mailto:info@mestprogramma.be">info@mestprogramma.be</a>, dan verwijderen wij deze informatie.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Verwerkingsdoelen</h2>
					<p>Mestprogramma verwerkt jouw persoonsgegevens voor de volgende doelen:</p>
					<ul className="privacy-list">
						<li>Je de mogelijkheid te bieden een account aan te maken</li>
						<li>Je te kunnen bellen of e-mailen indien dit nodig is om onze dienstverlening uit te kunnen voeren</li>
						<li>Je te informeren over wijzigingen van onze diensten en producten</li>
					</ul>
				</section>

				<section className="privacy-section">
					<h2>Bewaartermijnen</h2>
					<p>
						Mestprogramma bewaart je persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor je gegevens worden verzameld.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Delen van persoonsgegevens met derden</h2>
					<p>
						Mestprogramma verstrekt uitsluitend aan derden en alleen als dit nodig is voor de uitvoering van onze overeenkomst met jou of om te voldoen aan een wettelijke verplichting.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Cookies en vergelijkbare technieken</h2>
					<p>
						Mestprogramma gebruikt alleen technische en functionele cookies. En analytische cookies die geen inbreuk maken op je privacy. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen op jouw computer, tablet of smartphone.
					</p>
					<p>
						De cookies die wij gebruiken zijn noodzakelijk voor de technische werking van de website en jouw gebruiksgemak. Ze zorgen ervoor dat de website naar behoren werkt en onthouden bijvoorbeeld jouw voorkeursinstellingen. Ook kunnen wij hiermee onze website optimaliseren.
					</p>
					<p>
						Je kunt je afmelden voor cookies door je internetbrowser zo in te stellen dat deze geen cookies meer opslaat. Daarnaast kun je ook alle informatie die eerder is opgeslagen via de instellingen van je browser verwijderen.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Jouw rechten</h2>
					<p>
						Je hebt het recht om je persoonsgegevens in te zien, te corrigeren of te verwijderen. Dit kun je zelf doen via de persoonlijke instellingen van jouw account.
					</p>
					<p>
						Daarnaast heb je het recht om je eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van jouw persoonsgegevens door ons bedrijf en heb je het recht op gegevensoverdraagbaarheid. Dat betekent dat je bij ons een verzoek kan indienen om de persoonsgegevens die wij van jou beschikken in een computerbestand naar jou of een ander, door jou genoemde organisatie, te sturen.
					</p>
					<div className="info-box highlight">
						<p>
							<strong>Contact opnemen?</strong> Wil je gebruik maken van je recht op bezwaar en/of recht op gegevensoverdraagbaarheid of heb je andere vragen/opmerkingen over de gegevensverwerking, stuur dan een gespecificeerd verzoek naar <a href="mailto:info@mestprogramma.be">info@mestprogramma.be</a>.
						</p>
					</div>
					<p>
						Om er zeker van te zijn dat het verzoek tot inzage door jou is gedaan, vragen wij jou een kopie van je identiteitsbewijs bij het verzoek mee te sturen. Maak in deze kopie je pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van je privacy.
					</p>
					<p>
						Mestprogramma zal zo snel mogelijk, maar in ieder geval binnen vier weken, op jouw verzoek reageren.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Klachten indienen</h2>
					<p>
						Mestprogramma wil je er tevens op wijzen dat je de mogelijkheid hebt om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link:
					</p>
					<p>
						<a href="https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons" target="_blank" rel="noopener noreferrer" className="external-link">
							https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons
						</a>
					</p>
				</section>

				<section className="privacy-section">
					<h2>Beveiliging van persoonsgegevens</h2>
					<p>
						Mestprogramma neemt de bescherming van jouw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan.
					</p>
					<p>
						Als jij het idee hebt dat jouw gegevens toch niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op met onze klantenservice of via <a href="mailto:info@mestprogramma.be">info@mestprogramma.be</a>.
					</p>
				</section>

				<div className="privacy-footer-info">
					<p className="last-updated">Laatst bijgewerkt: {new Date().getFullYear()}</p>
				</div>
			</div>

			<footer className="privacy-footer">
				<div className="privacy-footer-inner">
					<div className="footer-left">&copy; {new Date().getFullYear()} mestprogramma</div>
					<div className="footer-right">
						Contact: <a href="mailto:info@mestprogramma.be" className="contact-email">info@mestprogramma.be</a>
					</div>
				</div>
			</footer>
		</div>
	);
}

export default PrivacyPolicy;
